export const SCHEDULING_MINUTE_STEP = 5

export const ceilPositiveMinutesToStep = (
  value: unknown,
  fallback: number | null = null,
  step = SCHEDULING_MINUTE_STEP,
): number | null => {
  const parsed = Number(value)

  if (!Number.isFinite(parsed) || parsed <= 0) return fallback

  return Math.ceil(parsed / step) * step
}

export const normalizeDurationInputValue = (value: unknown): string => {
  const rounded = ceilPositiveMinutesToStep(value)

  return rounded === null ? "" : String(rounded)
}
